export default __webpack_public_path__ + "static/media/KOD0117-min.a1643921.webp";